import { render, staticRenderFns } from "./PCheckbox.vue?vue&type=template&id=45ff0453&scoped=true"
import script from "./PCheckbox.vue?vue&type=script&lang=js"
export * from "./PCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PCheckbox.vue?vue&type=style&index=0&id=45ff0453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff0453",
  null
  
)

export default component.exports